module.exports = __webpack_public_path__ + "privathart2.8aeffbf5124f0f5bdfc168f4248a60bc.png";